import { Badge } from "@/components/ui/badge"
import { OfferingType, ServiceType } from "@/domain/offerings/offering"
import { FileText, Repeat } from "lucide-react"

export const getOfferingTypeIcon = (type: OfferingType) => {
  switch (type) {
    case OfferingType.ONE_TIME:
      return <FileText className="h-5 w-5 text-orange-600" />
    case OfferingType.RECURRING:
      return <Repeat className="h-5 w-5 text-blue-600" />
    default:
      return <FileText className="h-5 w-5 text-blue-600" />
  }
}

const getOfferingServiceTypeColor = (serviceType: ServiceType): string => {
  switch (serviceType) {
    case ServiceType.CREMACIONES:
      return 'text-green-600 bg-green-100 rounded-md'
    case ServiceType.ABONOS:
      return 'text-blue-600 bg-blue-100 rounded-md'
    case ServiceType.PARCELAS:
      return 'text-orange-600 bg-orange-100 rounded-md'
    default:
      return 'text-gray-600'
  }
}

const formatOfferingServiceType = (serviceType: ServiceType): string => {
  const serviceTypes: Record<ServiceType, string> = {
    [ServiceType.CREMACIONES]: 'Cremaciones',
    [ServiceType.ABONOS]: 'Abonos',
    [ServiceType.PARCELAS]: 'Parcelas',
  }
  return serviceTypes[serviceType] || serviceType
}

export const serviceTypeBadge = (serviceType: ServiceType) =>
  <Badge variant="outline" className={getOfferingServiceTypeColor(serviceType)}>
    {formatOfferingServiceType(serviceType)}
  </Badge>